export const SideBar = ( {children} )  => (
    <div className="sidebar">
        { children }
    </div>
)
